import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';
import { removeConnectionsMemoized } from '../';
import { allocationFragment } from '../fragments/allocation';

export const reportBuilderQuery = gql`
  query useReportBuilder($id: ID) {
    allReports(filters: { id: $id }) {
      edges {
        node {
          dbId
          name
          year
          stage
          status
          clonedFromId
          programName
          portfolioName
          feedbackType
          totalDonations
          tasks
          sponsorName
          startDate
          endDate
          fiscalYearStart
          fiscalYearEnd
          errors
          warnings
          programId
          createdAt
          version
          visibility
          cnOptedIn
          reportingType
          optedInFullReporting
          level1DonorName
          level1Budget
          level1ReachSucceedMatch
          orgAnnualExpenses
          orgExpensesFiscalYear
          storyFileId
          primaryInterventionType
          primaryInterventionSubtypes
          interventionDosageLevel
          interventionDosageNumber
          interventionDosageType
          successStory
          lessonLearned
          publicAccessToken
          customQuestionResponses
          primaryInterventionDescription
          programManager {
            accountId
            email
            firstName
            firstName
            phone
            title
          }
          ...AllocationFields
        }
      }
    }
  }
  ${allocationFragment}
`;

export const useReportBuilder = reportId => {
  if (!reportId || reportId === 'new') {
    return { data: [], refetch: () => undefined, loading: false };
  }
  const { data: rawData, refetch, loading } = useQuery(reportBuilderQuery, {
    variables: { id: reportId },
    fetchPolicy: 'no-cache',
  });

  const data =
    rawData?.allReports?.edges.length > 0
      ? removeConnectionsMemoized(rawData?.allReports)[0]
      : {};

  if (data?.tasks && data?.tasks.length > 2) {
    data.tasks = JSON.parse(data.tasks);
  }
  return { data, refetch, loading };
};
